import { FC, useCallback, useEffect, useState } from 'react';

import CTOContainer from 'components/CTOContainer';
import ProductsQuickAddCard from 'components/ProductsQuickAddCard';
import DownloadImagesModal from 'components/DownloadImagesModal';
import { useTranslation } from 'react-i18next';
import isEmpty from 'lodash/isEmpty';
import isNil from 'lodash/isNil';
import i18next from 'i18next';

import FileSaver from 'file-saver';
import { decodeBase64File } from 'utils/decodeBase64File';

import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const DownloadImages: FC = () => {
  const { t } = useTranslation();
  const [inputCodes, setInputCodes] = useState<string>('');
  const [loadingFetch, setLoadingFetch] = useState<boolean>(false);
  const [downloadModalOpen, setDownloadModalOpen] = useState<boolean>(false);

  useEffect(() => {
    const queryParams = new URLSearchParams(window.location.search);
    const lang = queryParams.get('lang');

    if (!isNil(lang)) {
      i18next.changeLanguage(lang || '{}');
    }
  }, []);

  const handleSetInput = useCallback((e: React.FormEvent<HTMLInputElement>) => {
    setInputCodes(e.currentTarget.value);
  }, []);

  const handleDownloadImages = useCallback(
    async (allImages: boolean) => {
      const skus = inputCodes.trim().split(/\s+/).filter(Boolean);
      if (isEmpty(skus)) return;

      const query = new URLSearchParams();
      skus.forEach((sku) => query.append('sku[]', sku));
      query.set('all_images', String(allImages));

      setLoadingFetch(true);
      try {
        const response = await fetch(`${process.env.REACT_APP_BASE_API_URL}/carnival/sku/images?${query.toString()}`);
        if (!response.ok) throw new Error('Image download request failed');

        const data = await response.json();
        const { file, filename } = decodeBase64File(data);
        FileSaver.saveAs(file, filename);
        setInputCodes('');
        setDownloadModalOpen(false);
      } catch {
        toast.error(`${t('Errors:DownloadImages')}`);
      } finally {
        setLoadingFetch(false);
      }
    },
    [inputCodes, t],
  );

  return (
    <CTOContainer>
      <div className="cto-page -downloadImages">
        <div className="cto-page__downloadComponentWrap">
          <ProductsQuickAddCard
            loading={loadingFetch}
            values={inputCodes}
            onChange={handleSetInput}
            title={t('DownloadImages:QuickDownloadProductImages')}
            buttonText={t('DownloadImages:DownloadButton')}
            imageDownload
            onOpenImageDownload={() => setDownloadModalOpen(true)}
          />
        </div>
        <DownloadImagesModal
          open={downloadModalOpen}
          loading={loadingFetch}
          onClose={() => setDownloadModalOpen(false)}
          onSubmit={handleDownloadImages}
        />
      </div>
    </CTOContainer>
  );
};

export default DownloadImages;
